import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { DigitalAssistantService } from '../../../digital-assistant.service';


@Component({
  selector: 'miq-chat-prompts',
  templateUrl: './chat-prompts.component.html',
  styleUrl: './chat-prompts.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class ChatPromptsComponent {
  readonly prompts = input<string[]>([]);
  readonly emitSelectedPrompt = output<string>();

  private readonly chatBotService = inject(DigitalAssistantService);

  handlePromptClick(prompt: string): void {
    this.chatBotService.isPromptsPanelOpen.update(prev => !prev);
    this.emitSelectedPrompt.emit(prompt);
  }
}
